<template>
  <v-row>
    <v-col cols="6" class="text-left pb-5">
      <button
        v-if="showComment < totalParentComment"
        class="viewMore text-md-subtitle-2 caption font-weight-bold"
        @click="$emit('loadmore')"
      >
        <span v-translate>View more comments</span>
      </button>
    </v-col>
    <v-col cols="6" class="text-left pb-5 text-right">
      <button
        class="viewMore text-md-subtitle-2 caption font-weight-bold"
        v-if="totalParentComment > 0"
        @click="$emit('loadmore')"
      >
        {{ showComment }}
        <translate>of</translate>
        {{ totalParentComment }}
        <translate
          :translate-n="totalParentComment"
          translate-plural="comments"
        >
          comment
        </translate>
      </button>
    </v-col>
  </v-row>
</template>
<script>
export default {
  name: "PostCommentMore",
  props: {
    totalParentComment: { type: Number, default: 0 },
    showComment: { type: Number, default: 0 },
  },
  methods: {
    onCommentCountClick() {
      if(this.showComment < this.totalParentComment) {
        this.$emit('loadmore')
      }
    }
  }
};
</script>